/**
 * Utility function to log FormData contents
 * @param formData The FormData object to inspect
 * @param title Optional title for the log group
 * @returns Object containing the parsed FormData contents
 */
export function inspectFormData(formData: FormData, title: string = 'FormData Contents'): { [key: string]: any } {
    console.group(title);
    
    const contents: { [key: string]: any } = {};
    
    try {
      formData.forEach((value, key) => {
        if (value instanceof File) {
          contents[key] = {
            type: 'File',
            name: value.name,
            size: value.size,
            mimeType: value.type
          };
          console.log(`${key}: File - ${value.name} (${value.size} bytes, ${value.type})`);
        } else {
          try {
            // Try to parse as JSON
            contents[key] = JSON.parse(value as string);
            console.log(`${key}:`, contents[key]);
          } catch {
            // If not JSON, store as is
            contents[key] = value;
            console.log(`${key}:`, value);
          }
        }
      });
    } catch (error) {
      console.error('Error inspecting FormData:', error);
    }
    
    console.groupEnd();
    return contents;
  }